import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { FaArrowLeft, FaCheckCircle, FaExclamationTriangle } from 'react-icons/fa';
import BlogForm from '../../../components/admin/forms/BlogForm';
import { apiFetch } from '../../../utils/api';

export default function CreateBlogPage() {
  const navigate = useNavigate();
  const [notification, setNotification] = useState(null);

  const handleCreateBlog = async (blogData) => {
    try {
      setNotification(null);
      const res = await apiFetch('/api/blogs', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(blogData),
      });

      if (!res.ok) {
        const errorData = await res.json().catch(() => ({}));
        throw new Error(errorData.message || 'Failed to create blog');
      }

      setNotification({ type: 'success', message: 'Blog created successfully! Redirecting...' });
      setTimeout(() => {
        navigate('/admin/blogs');
      }, 1200);
    } catch (err) {
      console.error(err);
      setNotification({ type: 'error', message: err.message || 'Failed to create blog post.' });
    }
  };

  return (
    <div className="space-y-6">
      {/* Top Navigation Bar */}
      <div className="flex flex-col gap-3 rounded-xl border border-slate-200 bg-white p-4 sm:p-5 shadow-2xs sm:flex-row sm:items-center sm:justify-between">
        <div>
          <div className="flex items-center gap-1.5 text-[11px] font-medium text-slate-500">
            <Link to="/admin/blogs" className="hover:text-slate-800">Blogs</Link>
            <span>/</span>
            <span className="text-amber-600 font-semibold">New Article</span>
          </div>
          <h1 className="mt-0.5 text-lg font-bold text-slate-900 sm:text-xl">Create New Blog</h1>
          <p className="text-xs text-slate-500">Compose and publish articles with rich text and SEO metadata.</p>
        </div>

        <Link
          to="/admin/blogs"
          className="inline-flex items-center gap-1.5 rounded-lg border border-slate-200 bg-white px-3.5 py-2 text-xs font-semibold text-slate-700 shadow-2xs transition hover:bg-slate-50"
        >
          <FaArrowLeft className="text-[10px]" /> Back to All Blogs
        </Link>
      </div>

      {/* Notification Toast */}
      {notification && (
        <div
          className={`flex items-center gap-3 rounded-2xl p-4 text-sm font-medium shadow-sm transition ${
            notification.type === 'success'
              ? 'border border-emerald-200 bg-emerald-50 text-emerald-800'
              : 'border border-red-200 bg-red-50 text-red-800'
          }`}
        >
          {notification.type === 'success' ? <FaCheckCircle className="text-emerald-600" /> : <FaExclamationTriangle className="text-red-600" />}
          <span>{notification.message}</span>
        </div>
      )}

      {/* Main Blog Form */}
      <BlogForm onSubmit={handleCreateBlog} />
    </div>
  );
}
